import { Vue } from 'nuxt-property-decorator';

export default Vue.extend({
  name: 'LazyImage' as string,
  props: {
    src: {
      type: [Function, String],
      default: null,
    },
    thumbSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadedSrc: null,
    };
  },
  watch: {
    src: {
      immediate: true,
      async handler() {
        // @ts-ignore
        if (this.src) {
          // @ts-ignore
          this.loadedSrc = typeof this.src === "function" ? await this.src() : this.src;
        }
      },
    },
  },
  computed: {
    backgroundImage() {
      if (!this.loadedSrc) return `url(${this.thumbSrc})`;

      // @ts-ignore
      return `url(${this.loadedSrc}), url(${this.thumbSrc})`
    }
  },
})
